const scoreTable = {
    /*I-1中学生用換算表
    **粗点:換算点
    **検査3形態照合検査
    */
    scoreTable3: {
        36:118,
        35:114,
        34:111,
        33:107,
        32:103,
        31:100,
        
        30:96,
        29:93,
        28:89,
        27:86,
        26:82,
        
        25:78,
        24:75,
        23:71,
        22:68,
        21:64,
        
        20:60,
        19:57,
        18:53,
        17:50,
        16:46,
        
        15:42,
        14:39,
        13:35,
        12:32,
        11:28,
        
        10:24,
        9:21,   
        8:17,
        7:14,
        6:10,
        
        5:6,
        4:3,
        3:0,
        2:-3,
        1:-7,     
        0:-11
        },
        
        /*I-1中学生用換算表
        **粗点:換算点
        **検査4名詞比較検査
        */
        scoreTable4:{
        70:196,
        69:193,
        68:190,
        67:187,
        66:184,
        
        65:181,
        64:177,
        63:174,
        62:171,
        61:168,
        
        60:165,
        59:162,
        58:159,
        57:155,
        56:152,
        
        55:149,
        54:146,
        53:143,
        52:140,
        51:137,
        
        50:133,
        49:130,
        48:127,
        47:124,
        46:121,
        
        45:118,
        44:144,
        43:111,
        42:108,
        41:105,
        
        40:102,
        39:99,
        38:96,
        37:92,
        36:89,
        
        35:86,
        34:83,
        33:80,
        32:77,
        31:74,
        
        30:70,
        29:67,
        28:64,
        27:61,
        26:58,
        
        25:55,
        24:51,
        23:48,
        22:45,
        21:42,
        
        20:39,
        19:36,
        18:33,
        17:29,
        16:26,
        
        15:23,
        14:20,
        13:47,
        12:14,
        11:11,
        
        10:7,
        9:4,
        8:1,
        7:-1,
        6:-4,
        
        5:-7,
        4:-11,
        3:-14,
        2:-17,
        1:-20,
        0:-23
        },
        
        /*I-1中学生用換算表
        **粗点:換算点
        **検査5図柄照合検査
        */
        scoreTable5:{
        24:92,
        23:87,
        22:81,
        21:76,
        
        20:70,
        19:65,
        18:59,
        17:54,
        16:48,
        
        15:43,
        14:38,
        13:32,
        12:27,
        11:21,
        
        10:16,
        9:10,
        8:5,
        7:0,
        6:-5,
        
        5:-11,
        4:-16,
        3:-21,
        2:-27,
        1:-32,
        0:-38
        },
        
        /*I-1中学生用換算表
        **粗点:換算点
        **検査6平面図判断検査
        */
        scoreTable6:{
        24:118,
        23:113,
        22:109,
        21:104,
        
        20:99,
        19:94,
        18:89,
        17:85,
        16:80,
        
        15:75,
        14:70,
        13:66,
        12:61,
        11:56,
        
        10:51,
        9:46,
        8:42,
        7:37,
        6:32,
        
        5:27,
        4:23,
        3:18,
        2:13,
        1:8,
        0:3
        },
        
        /*I-1中学生用換算表
        **粗点:換算点
        **検査7計算検査
        */
        scoreTable7:{
        30:102,
        29:99,
        28:95,
        27:92,
        26:89,
        
        25:86,
        24:83,
        23:80,
        22:77,
        21:74,
        
        20:70,
        19:67,
        18:64,
        17:61,
        16:58,
        
        15:55,
        14:52,
        13:48,
        12:45,
        11:42,
        
        10:39,
        9:36,
        8:33,
        7:30,
        6:27,
        
        5:23,
        4:20,
        3:17,
        2:14,
        1:11,
        0:8
        },
        
        /*I-1中学生用換算表
        **粗点:換算点
        **検査8語意検査
        */
        scoreTable8:{
        40:127,
        39:124,
        38:121,
        37:119,
        36:116,
        
        35:113,
        34:110,
        33:107,
        32:105,
        31:102,
        
        30:99,
        29:96,
        28:94,
        27:91,
        26:88,
        
        25:85,
        24:83,
        23:80,
        22:77,
        21:74,
        
        20:72,
        19:69,
        18:66,
        17:63,
        16:60,
        
        15:58,
        14:55,
        13:52,
        12:49,
        11:47,
        
        10:44,
        9:41,
        8:38,
        7:36,
        6:33,
        
        5:30,
        4:27,
        3:24,
        2:22,
        1:19,
        0:16
        },
        
        /*I-1中学生用換算表
        **粗点:[換算点G(知的), 換算点S(空間)]
        **検査9立体図判断検査
        */
        scoreTable9:{
        28:[55,84],
        27:[53,81],
        26:[51,78],
        
        25:[49,75],
        24:[47,71],
        23:[44,68],
        22:[42,65],
        21:[40,62],
        
        20:[38,59],
        19:[36,56],
        18:[34,53],
        17:[31,49],
        16:[29,46],
        
        15:[27,43],
        14:[25,40],
        13:[23,37],
        12:[21,34],
        11:[18,31],
        
        10:[16,27],
        9:[14,24],
        8:[12,21],
        7:[10,18],
        6:[8,15],
        
        5:[5,12],
        4:[3,8],
        3:[1,5],
        2:[0,2],
        1:[-2,0],
        0:[-4,-3]
        },
        
        /*I-1中学生用換算表
        **粗点:[換算点G(知的), 換算点V(言語)]
        **検査10文章完成険査
        */
        scoreTable10:{
        48:[72,67],
        47:[70,66],
        46:[69,65],
        
        45:[68,64],
        44:[66,63],
        43:[65,61],
        42:[64,60],
        41:[62,59],
        
        40:[61,58],
        39:[59,57],
        38:[58,56],
        37:[57,54],
        36:[55,53],
        
        35:[54,52],
        34:[53,51],
        33:[51,50],
        32:[50,48],
        31:[48,47],
        
        30:[47,46],
        29:[46,45],
        28:[44,44],
        27:[43,43],
        26:[42,41],
        
        25:[40,40],
        24:[39,39],
        23:[37,38],
        22:[36,37],
        21:[35,35],
        
        20:[33,34],
        19:[32,33],
        18:[31,32],
        17:[29,31],
        16:[28,30],
        
        15:[27,28],
        14:[25,27],
        13:[24,26],
        12:[22,25],
        11:[21,24],
        
        10:[20,22],
        9:[18,21],
        8:[17,20],
        7:[16,19],
        6:[14,18],
        
        5:[13,17],
        4:[11,15],
        3:[10,14],
        2:[9,13],
        1:[7,12],
        0:[6,11]
        },
        
        /*I-1中学生用換算表
        **粗点:[換算点G(知的), 換算点N(数理)]
        **検査11算数応用検査
        */
        scoreTable11:{
        20:[76,83],
        19:[73,79],
        18:[69,76],
        17:[66,72],
        16:[63,69],
        
        15:[59,65],
        14:[56,62],
        13:[53,58],
        12:[49,55],
        11:[46,52],
        
        10:[43,48],
        9:[40,45],
        8:[36,41],
        7:[33,38],
        6:[30,34],
        
        5:[26,31],
        4:[23,28],
        3:[20,24],
        2:[16,21],
        1:[13,17],
        0:[10,14]
        },
};
    
        export default scoreTable;